import React from "react";
import "../../theme/skeleton.css";

export interface SkeletonBlockProps {
    height?: number | string;
    width?: number | string;
    minWidth?: number | string;
    borderRadius?: number | string;
    className?: string;
    style?: React.CSSProperties;
}

const SkeletonBlock: React.FC<SkeletonBlockProps> = ({
    height = 16,
    width = "100%",
    minWidth,
    borderRadius = 8,
    className = "",
    style,
}) => (
    <div
        className={`skeleton-block skeleton-blink ${className}`.trim()}
        style={{
            height,
            width,
            minWidth,
            borderRadius,
            ...style,
        }}
        aria-hidden="true"
    />
);

export default SkeletonBlock;
